import { NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppConfig } from '../services/config/AppConfig';
import { LoginService } from '../services/login.service';
import { SwalService } from '../services/swal.service';
import { TokenStorage } from './auth/token.storage';

export function throwIfAlreadyLoaded(parentModule: unknown, moduleName: string): void {
    if (parentModule) {
        throw new Error(`${moduleName} has already been loaded. Import it in AppModule only.`);
    }
}

@NgModule({
    imports: [CommonModule],
    providers: [
        LoginService,
        SwalService,
        TokenStorage,
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: (appConfig: AppConfig) => () => appConfig.Init(),
            deps: [AppConfig, LoginService],
            multi: true
        }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
